import styled from 'styled-components'

import { helpers } from 'styles'

export const Title = styled.h1`
	font-weight: ${helpers.font.weight.semiBold};
	font-size: 26px;
	line-height: 36px;
	margin: 0 0 24px;
`
